import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
  Paper,
  Card,
  CardContent,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  CircularProgress,
  TableRow,
  Typography,
  TextField,
  Backdrop
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React, { useEffect } from 'react';
import Highlighter from 'react-highlight-words';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import {
  setDefectFilterKey,
  setLabourSelection,
  setMaterialSelection,
  setSelection,
  changeFilter
} from '../../store/actions';
import { setTask } from '../../store/actions/taskActions';
import { FORCED_LEVEL1_TENANT_ID } from '../../store/reducers/defects';
import { getUser } from '../../utils/Common';

const useStyles = makeStyles(theme => ({
  table: {
    width: '100%',
    minHeight: 600,
    maxHeight: 600
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
}));

const DefectTable = props => {
  const classes = useStyles();
  const { selected } = props.defects;
  const { t } = useTranslation('work_order');
  const SessionUser = getUser();
  const isLevel1Locked = parseInt(SessionUser?.TenantId, 10) === FORCED_LEVEL1_TENANT_ID;
  const [alertOpen, setAlertOpen] = React.useState(false);
  const [alertMsg, setAlertMsg] = React.useState('');
  const [showTable, setshowTable] = React.useState(false);

  const [labourMsg, setLabourMsg] = React.useState('');

  const handleClick = (event, name) => {
    const { selected } = props.defects;
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      // Add
      newSelected = [...selected, name];
      const pickedDefect = props.defects.defectsTable[name];

      if (pickedDefect?.Labours && pickedDefect.Labours.length > 0) 
      {
        const template = t('DefectRequiresLabour'); // "Defect: @Defect requires labour: @Labour"

        const msg = template
          .replace('@Defect', pickedDefect.DefectDesc)
          .replace('@Labour', pickedDefect.Labours[0].LabourDesc);

        setLabourMsg(msg);
      } 
      else 
      {
        setLabourMsg('');
      }

        
      const kul_hizmet_kodu = pickedDefect?.UserCode;

      const hizmet_isciligi = props.labours.Data.filter(
        d => d.LabourCode === kul_hizmet_kodu
      );
      if (hizmet_isciligi.length > 0) {
        props.setLabourSelection(name, [kul_hizmet_kodu]);
      }
    } else {
      // Remove
      newSelected = [
        ...selected.slice(0, selectedIndex),
        ...selected.slice(selectedIndex + 1)
      ];
      props.setLabourSelection(name, []);
      props.setMaterialSelection(name, []);
    }
    props.changeFilter(true);
    props.setDefectFilterKey(
      '',
      props.defects.level1Selected,
      props.defects.level2Selected
    );
    props.setSelection(newSelected);
  };

  const isSelected = name => selected.indexOf(name) !== -1;

  const Level1Search = (Param, Type) => {
    props.changeFilter(true);
    props.setDefectFilterKey(props.defects.filterKey, Param, Type);
    setshowTable(false);
  };

  const LevelSearch = Value => {
    props.changeFilter(true);
    props.setDefectFilterKey(
      props.defects.filterKey,
      props.defects.level1Selected,
      Value
    );
    setshowTable(true);
  };

  const handleFilterKeyChange = key => {
    props.changeFilter(true);
    props.setDefectFilterKey(
      key,
      props.defects.level1Selected,
      props.defects.level2Selected
    );
  };

  const highlight = text => {
    return (
      <Highlighter
        searchWords={[props.defects.filterKey]}
        autoEscape={true}
        textToHighlight={text}
      />
    );
  };


  return (
    <Grid container spacing={1}>
      <Backdrop className={classes.backdrop} open={props.loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Grid item xs={12} align="left">
        <Card className={classes.root}>
          <CardContent>
            <Grid container spacing={1}>
              <Grid item xs={12} align="left">
                <Autocomplete
                  size="small"
                  fullWidth
                  disabled={isLevel1Locked}
                  disableClearable={isLevel1Locked}
                  options={props.defects.level1}
                  value={
                    props.defects.level1.find(
                      l => l.level1Id === props.defects.level1Selected
                    ) || null
                  }
                  getOptionLabel={option => (option ? option.level1Desc : '')}
                  getOptionSelected={(option, value) =>
                    option.level1Id === value.level1Id
                  }
                  onChange={(event, value) =>
                    Level1Search(value ? value.level1Id : 0, 0)
                  }
                  renderInput={params => (
                    <TextField
                      {...params}
                      label={t('lblAllCatagoryLevel1')}
                      variant="outlined"
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} align="left">
                <Autocomplete
                  size="small"
                  fullWidth
                  options={props.defects.level2Filtered}
                  value={
                    props.defects.level2Filtered.find(
                      l => l.level2Id === props.defects.level2Selected
                    ) || null
                  }
                  getOptionLabel={option => (option ? option.level2Desc : '')}
                  getOptionSelected={(option, value) =>
                    option.level2Id === value.level2Id
                  }
                  onChange={(event, value) =>
                    LevelSearch(value ? value.level2Id : 0)
                  }
                  renderInput={params => (
                    <TextField
                      {...params}
                      label={t('lblAllCatagoryLevel2')}
                      variant="outlined"
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} align="left">
                <TextField
                  size="small"
                  fullWidth
                  label={t('HizmetArama')}
                  placeholder={t('HizmetArama')}
                  value={props.defects.filterKey}
                  onChange={e => handleFilterKeyChange(e.target.value)}
                  variant="outlined"
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} align="left">
         {labourMsg && (
          <Typography variant="body2" style={{ margin: '10px 0', color: 'blue' }}>
            {labourMsg}
          </Typography>
        )}
        <TableContainer className={classes.table} component={Paper}>
          {showTable ? (
            <Table size="small" aria-label="defect table">
              <TableBody>
                {props.defects.filtered &&
                  props.defects.filtered
                    // .sort(s => (isSelected(s.Code) ? -1 : 1))
                    .map((row, index) => {
                      const labelId = `enhanced-table-checkbox-${index}`;
                      const isItemSelected = isSelected(row.Code);
                      return (
                        <TableRow
                          onClick={event => handleClick(event, row.Code)}
                          role="checkbox"
                          aria-checked={isItemSelected}
                          tabIndex={-1}
                          key={row.Code}
                          selected={isItemSelected}
                        >
                          <TableCell component="th" scope="row">
                            <b>{highlight(row.UserCode)}</b>{' '}
                            {highlight(row.DefectDesc)}
                          </TableCell>
                          <TableCell padding="checkbox">
                            <Checkbox
                              color="primary"
                              checked={isItemSelected}
                              inputProps={{ 'aria-labelledby': labelId }}
                            />
                          </TableCell>
                        </TableRow>
                      );
                    })}
              </TableBody>
            </Table>
          ) : (
            ''
          )}
        </TableContainer>
      </Grid>
      <Dialog open={alertOpen} onClose={() => setAlertOpen(false)}>
        <DialogContent>
          <Typography variant="h6" component="h4">
            {alertMsg}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAlertOpen(false)} color="primary">
            {t('Tamam')}
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
};

const mapStateToProps = state => ({
  defects: state.defectReducer,
  labours: state.labourReducer,
  filterChange: state.filterChange,
  loading: state.defectReducer.loading,
  tasks: state.tasks1
});

const mapDispatchToProps = {
  setSelection,
  setLabourSelection,
  setMaterialSelection,
  setDefectFilterKey,
  changeFilter,
  setTask
};

export default connect(mapStateToProps, mapDispatchToProps)(DefectTable);
